// src/input-event.ts
var getWindow = (el) => el.ownerDocument.defaultView || window;
function getDescriptor(el, options) {
  const { type, property = "value" } = options;
  const proto = getWindow(el)[type].prototype;
  return Object.getOwnPropertyDescriptor(proto, property) ?? {};
}
function setElementValue(el, value, option) {
  const descriptor = getDescriptor(el, option);
  descriptor.set?.call(el, value);
}
function dispatchInputValueEvent(el, value) {
  if (!el)
    return;
  const win = getWindow(el);
  if (!(el instanceof win.HTMLInputElement))
    return;
  const desc = getDescriptor(el, { type: "HTMLInputElement", property: "value" });
  desc.set?.call(el, value);
  const event = new win.Event("input", { bubbles: true });
  el.dispatchEvent(event);
}
function dispatchInputCheckedEvent(el, checked) {
  if (!el)
    return;
  const win = getWindow(el);
  if (!(el instanceof win.HTMLInputElement))
    return;
  const desc = getDescriptor(el, { type: "HTMLInputElement", property: "checked" });
  desc.set?.call(el, checked);
  const event = new win.Event("click", { bubbles: true });
  el.dispatchEvent(event);
}

export {
  setElementValue,
  dispatchInputValueEvent,
  dispatchInputCheckedEvent
};
